import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import EnergyEfficiencyYearlyView from '../../ValueDashboardPage/EnergyEfficiency/EnergyEfficiencyYearlyView';

const EnergySavingsPowerPage = observer(() => {
  return (
    <Container>
      <EnergyEfficiencyYearlyView
        className="yearly-view"
        style={{ display: 'flex' }}
        tabKey={'power'}
        animation={false}
      />
    </Container>
  );
});

const Container = styled.div`
  padding-bottom: ${({ theme: { token } }) => token.paddingXL}px;

  .card {
    width: 920px;
    margin-left: auto;
    margin-right: auto;
    margin-top: ${({ theme: { token } }) => token.marginLG}px;

    .efficiency-card {
      border: none;
    }
  }

  .description {
    margin-bottom: ${({ theme: { token } }) => token.marginXL}px;
  }
`;

export default EnergySavingsPowerPage;
